const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/AddToCalendarComponent/AddToCalendarComponent.tsx';
import React from 'react';
import MuiIconBtn from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { Button, Menu, MenuItem } from '@mui/material';
import moment from 'moment';
import { CalendarEvent, google, ics, office365, outlook, yahoo } from 'calendar-link';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { css, cx } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';
import { useIntl } from 'react-intl';
import textMap from './translations';

const dropdownButton = css`
    border: 1px solid ${colors.grey[400]};
    font-weight: normal;
    color: ${colors.grey[600]};
`;

type AddToCalendarOptions = 'Apple' | 'Google' | 'iCal' | 'Microsoft365' | 'Outlook.com' | 'Outlook' | 'Yahoo';

type AddToCalendarProps = {
    showAsIcon?: boolean;
    title: string;
    description?: string;
    startDate: string;
    endDate: string;
    options: AddToCalendarOptions[];
    location?: string;
    inputProps?: any;
    responsiblePerson?: string | undefined;
};

const AddToCalendarComponent = (props: AddToCalendarProps) => {
    const { title, startDate, endDate, options, location, description, showAsIcon, responsiblePerson } = props;
    const { formatMessage } = useIntl();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (e: any) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const duration = moment(endDate).diff(startDate, 'minutes');

    const getDescriptionWithResponsilbePerson = () => {
        return `${responsiblePerson ? formatMessage(textMap.responsiblePerson, { responsiblePerson }) : ''}
${description || ''}`;
    };

    const onItemClicked = (option: AddToCalendarOptions) => {
        const calendarEvent: CalendarEvent = {
            title,
            location: location || '',

            description: getDescriptionWithResponsilbePerson(),
            start: moment(startDate),
            duration: [duration, 'minutes'],
        };
        switch (option) {
            case 'Yahoo':
                window.open(yahoo(calendarEvent), '_blank');
                break;
            case 'Outlook.com':
                window.open(outlook(calendarEvent), '_blank');
                break;
            case 'Microsoft365':
                window.open(office365(calendarEvent), '_blank');
                break;
            case 'Google':
                window.open(google(calendarEvent), '_blank');
                break;
            case 'Outlook':
            case 'iCal':
            case 'Apple':
                window.open(ics(calendarEvent), '_blank');
                break;
        }
        handleClose();
    };

    const getOptionJSX = (option: AddToCalendarOptions) => {
        return (
            <MenuItem onClick={() => onItemClicked(option)} key={`${title}_${option}`} value={option}>
                {option}
            </MenuItem>
        );
    };
    if (options.length > 0) {
        return showAsIcon ? (
            <>
                <MuiIconBtn aria-controls="AddToCalendar" aria-haspopup="true" onClick={handleClick}>
                    <Icon className="icons8-calendar" />
                </MuiIconBtn>
                <Menu id="AddToCalendar" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                    {options.map(option => getOptionJSX(option))}
                </Menu>
            </>
        ) : (
            <>
                <Button
                    aria-controls="AddToCalendar"
                    aria-haspopup="true"
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                    color={'inherit'}
                    className={cx(dropdownButton, props.inputProps?.className)}
                    style={{ textTransform: 'none' }}
                >
                    {formatMessage(textMap.addToCalendar)}
                </Button>
                <Menu id="AddToCalendar" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                    {options.map(option => getOptionJSX(option))}
                </Menu>
            </>
        );
    } else {
        return null;
    }
};

export default AddToCalendarComponent;
